import React, { useState } from 'react';
import { useNavigate  , Link} from 'react-router-dom';

//URL
import {URL} from '../../../context/URL'

//SweetAlrt
import {SweetAlrt} from '../../../context/SweetAlrt'

//mui
import { Typography , Alert , styled , TextField } from '@mui/material'


//css
const AlrtBox = styled(Typography)(({theme})=>({
    color:'red',
    marginTop:'-18px',
    marginBottom:'5px',
    paddingLeft:'40px',
    fontSize:'15px',
    "@media (max-width:390px) ":{
        fontSize:'10px'
    }
 }))

export default function Email_verifiy() {
    const navigate = useNavigate();
    
    const [email , setEmail] = useState("");
    const [emailAlrt , setEmailAlrt] = useState(false);
    const [checkUser , setCheckUser] = useState(false);

    const handle_confrom = async()=>{

     
      
        //email validation
        let emailPatten = "([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])"
        let rEmail = new RegExp(emailPatten);

        if(rEmail.test(email)){
            setEmailAlrt(false);
        }else{
            setEmailAlrt(true)
        }

        if(!emailAlrt){
            if(rEmail.test(email)){
                try{
                   let result = await fetch(`${URL}/user/getUser/${email}`);
                   result =await result.json();

                   console.log(result.length);
                   if(result.length != 0){
                       setCheckUser(false);
                       SweetAlrt("OTP send " , "success");
                       navigate(`/OTP/Forget_password/${email}`)
                   }else{
                    setCheckUser(true);
                   }
                }catch(error){
                    SweetAlrt("OTP send " , "error");
                    console.log("user find aip error : " + error);
                }
            }
        }
    }

  return (
    <>
        
    <div className="container" style={{background :'#f2f2f2'}}>
        <div className="wrapper" style={{margin:'0px' , background :  '#FFFF'}}>
            <div className="title"><span>Foreget password</span></div>

            <div >
            {
              checkUser &&   <Alert severity="error" style={{margin : '1rem 1rem 0rem 1rem'}}>This eamil id not available!</Alert>
            }
            </div>

            <form>
            {/* <div className="row">
                <i className="fas fa-envelope"></i>
                <input type="email" placeholder="Email " onChange={(e)=>setEmail(e.target.value)} required/>
            </div>
            {
                    emailAlrt && <AlrtBox>* email is abc@gmail.com</AlrtBox>
            } */}

            <div style={{marginBottom : '1rem'}}>
                {
                    emailAlrt ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Email"
                    onChange={(e)=>setEmail(e.target.value)}
                    helperText="invaild email"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="Email"
                        onChange={(e)=>setEmail(e.target.value)}
                    />
                }
             </div>

     
            
            <div className="row button"onClick={handle_confrom}>
                <input type="button"  value="Send OTP"  />
            </div>
            </form>
        </div>
        </div>
    </>
  )
}
